import React from 'react';
import { Database, Shield, Zap, ArrowRight, CheckCircle2 } from 'lucide-react';

const ProductsSection = () => {
  const products = [
    {
      icon: <Database size={40} color="#00FFD1" />,
      title: 'Plan Básico',
      description: 'Orquestador de DR híbrido para infraestructuras mixtas on-premise y cloud.',
      price: '$2,500 MXN', // Precio añadido
      features: [
        'Replicación automática de datos críticos',
        'Recuperación con un solo clic',
        'Scripts de orquestación auto-generados',
        'Soporte para nubes y entornos locales.'
      ]
    },
    {
      icon: <Shield size={40} color="#00FFD1" />,
      title: 'Plan Pro - GuardianOS',
      description: 'Servicio de auditoría y hardening de seguridad para Linux con enfoque en inmutabilidad.',
      price: '$4,500 MXN', // Precio añadido
      features: [
        'Auditoría continua de seguridad',
        'Benchmarks CIS Level 2',
        'Detección de desviaciones',
        'Corrección automatizada'
      ]
    },
    {
      icon: <Zap size={40} color="#00FFD1" />,
      title: 'Plan Premium - Optimización',
      description: 'Tuning adaptativo de latencia cero para aplicaciones de microservicios críticos.',
      price: '$15,000 MXN', // Precio añadido
      features: [
        'Monitoreo con eBPF',
        'Ajuste de kernel en tiempo real',
        'Optimización de prioridad de tráfico',
        'Ideal para Fintech y Telecom'
      ]
    }
  ];

  return (
    <section id="products" style={{
      padding: '100px 7.6923%',
      background: '#000000',
      position: 'relative'
    }}>
      <div className="grid-pattern" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none'
      }} />

      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 2
      }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#00FFD1', fontSize: '14px', fontWeight: 500 }}>NUESTROS PRODUCTOS</span>
          </div>
          <h2 style={{ fontSize: '48px', fontWeight: 600, color: '#FFFFFF', marginBottom: '20px' }}>
            Soluciones Empresariales Linux
          </h2>
          <p style={{ fontSize: '20px', color: 'rgba(255, 255, 255, 0.85)', maxWidth: '700px', margin: '0 auto' }}>
            Tres productos especializados para transformar tu infraestructura tecnológica
          </p>
        </div>

        {/* Products Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '40px'
        }} className="products-grid">
          {products.map((product, index) => (
            <div
              key={index}
              className="dark-hover"
              style={{
                background: '#121212',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                padding: '40px',
                transition: 'all 0.4s ease-in-out',
                cursor: 'pointer'
              }}
            >
              <div style={{ marginBottom: '24px' }}>{product.icon}</div>

              <h3 style={{ fontSize: '24px', fontWeight: 600, color: '#FFFFFF', marginBottom: '16px' }}>
                {product.title}
              </h3>

              <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', marginBottom: '24px' }}>
                {product.description}
              </p>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {product.features.map((feature, fIndex) => (
                  <li key={fIndex} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '14px', color: 'rgba(255, 255, 255, 0.6)' }}>
                    <CheckCircle2 size={16} color="#00FFD1" style={{ marginTop: '2px', flexShrink: 0 }} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* SECCIÓN DE PRECIO AÑADIDA */}
              <div style={{ marginTop: '32px' }}>
                <span style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '12px', display: 'block', marginBottom: '4px' }}>
                  
                </span>
                <span style={{ color: '#00FFD1', fontSize: '28px', fontWeight: 700, letterSpacing: '-0.5px' }}>
                  
                </span>
              </div>

              {/* CTA */}
              <div style={{
                marginTop: '24px',
                paddingTop: '24px',
                borderTop: '1px solid rgba(255, 255, 255, 0.15)'
              }}>
                <button
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#00FFD1',
                    fontSize: '16px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'gap 0.3s ease',
                    padding: 0
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.gap = '12px'}
                  onMouseLeave={(e) => e.currentTarget.style.gap = '8px'}
                >
                  Más información
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx="true">{`
        @media (max-width: 1024px) {
          .products-grid { grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important; }
        }
        @media (max-width: 767px) {
          .products-grid { grid-template-columns: 1fr !important; }
        
        .dark-hover:hover {
          border-color: #00FFD1 !important;
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 255, 209, 0.05);
        }
      `}</style>
    </section>
  );
};

export default ProductsSection;
